import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { PaymentReceiptRepository } from "../Repositories/payment-receipt.repository";
import { InsuranceReceiptEmailRequest } from "../Types/Interfaces/payment-receipt-email.interface";
import { PaymentReceiptFilter } from "../Types/Interfaces/payment-receipt-filter.interface";
import { PaymentReceipt } from "../Types/Interfaces/payment-receipt.interface";

@Injectable({
  providedIn: "root",
})
export class PaymentReceiptService {
  constructor(private paymentReceiptRepository: PaymentReceiptRepository, private fileHandlerService: FileHandlerService) {}

  public getPaymentReceipts(paymentReceiptFilter: PaymentReceiptFilter): Observable<PaymentReceipt[]> {
    return this.paymentReceiptRepository.getPaymentReceipts(paymentReceiptFilter);
  }
  public getPaymentReceiptTypes(): Observable<DropdownOption[]> {
    return this.paymentReceiptRepository.getPaymentReceiptTypes();
  }

  public getPaymentReceiptReport(receiptNumber: string): Observable<void> {
    return this.paymentReceiptRepository
      .getPaymentReceiptReport(receiptNumber)
      .pipe(map(this.fileHandlerService.openPdfInNewTab));
  }

  public sendPaymentReceiptEmail(paymentReceipt: InsuranceReceiptEmailRequest): Observable<ShareMessageResponse> {
    return this.paymentReceiptRepository.sendPaymentReceiptEmail(paymentReceipt);
  }
}
